export const ActionItemsTitleText = "Action Items";
export const ActionItemsHelperText = "Complete the following items to help us help you help your customers.";

export const DescriptionColumnText = "Description";
export const ActionTypeColumnText = "Action Type";
export const DateAssignedColumnText = "Date Assigned";

export const GoButtonText = "GO";
export const DismissLinkText = "Dismiss";

export const NoActionItemsText = "No action items... yet!";
export const NoActionItemsSubText = "When one of your orders needs attention it will appear here.";
